<app-page-header subtitle="OrderDirect Inkoopfacturen"> </app-page-header>

<div class="text-container">
    <div class="row mb-3">
        <div class="col-24">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div class="d-flex gap-2 align-items-center flex-wrap">
                    <mat-form-field class="mb-0" appearance="outline" style="width: 300px">
                        <mat-label>Zoeken...</mat-label>
                        <input [formControl]="fcSearch" matInput placeholder="Bonnummer, crediteur, AFAS order..." />
                        @if (fcSearch.value) {
                            <button (click)="fcSearch.setValue('')" matSuffix mat-icon-button>
                                <i class="fas fa-times"></i>
                            </button>
                        }
                    </mat-form-field>
                    <button class="btn btn-success" (click)="triggerSync()" type="button">
                        <i class="fas fa-sync"></i> 1. Ophalen uit OrderDirect
                    </button>
                    <button class="btn btn-success mx-2" (click)="sendAllToAfas()" type="button">
                        <i class="fas fa-paper-plane"></i> 2. Verstuur naar AFAS
                    </button>
                </div>
                <div class="btn-group" role="group">
                    <button
                        class="btn"
                        [class.btn-primary]="statusFilter === null"
                        [class.btn-outline-primary]="statusFilter !== null"
                        (click)="filterByStatus(null)"
                        type="button">
                        Alle
                    </button>
                    <button
                        class="btn"
                        [class.btn-info]="statusFilter === 'new'"
                        [class.btn-outline-info]="statusFilter !== 'new'"
                        (click)="filterByStatus('new')"
                        type="button">
                        Nieuw
                    </button>
                    <button
                        class="btn"
                        [class.btn-warning]="statusFilter === 'pending'"
                        [class.btn-outline-warning]="statusFilter !== 'pending'"
                        (click)="filterByStatus('pending')"
                        type="button">
                        In behandeling
                    </button>
                    <button
                        class="btn"
                        [class.btn-success]="statusFilter === 'completed'"
                        [class.btn-outline-success]="statusFilter !== 'completed'"
                        (click)="filterByStatus('completed')"
                        type="button">
                        Voltooid
                    </button>
                    <button
                        class="btn"
                        [class.btn-danger]="statusFilter === 'failed'"
                        [class.btn-outline-danger]="statusFilter !== 'failed'"
                        (click)="filterByStatus('failed')"
                        type="button">
                        Mislukt
                    </button>
                </div>
            </div>
        </div>
    </div>

    @if (loading) {
        <div class="text-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Laden...</span>
            </div>
        </div>
    }

    @if (!loading && invoices.length === 0) {
        <div class="alert alert-info">Geen inkoopfacturen gevonden.</div>
    }

    @if (!loading && invoices.length > 0) {
        <div class="row">
            <div class="col-md-24">
                <div class="table-responsive">
                    <table class="table table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Bonnummer</th>
                                <th>Boekstuknummer</th>
                                <th>Datum</th>
                                <th>Crediteur</th>
                                <th>Naam</th>
                                <th class="text-end">Prijs</th>
                                <th class="text-end">Excl. BTW OD</th>
                                <th class="text-end">Incl. BTW OD</th>
                                <th class="text-end">Incl. BTW AFAS</th>
                                <th>AFAS Order</th>
                                <th>Status</th>
                                <th>Foutmelding</th>
                                <th>Geimporteerd uit OD</th>
                                <th>Acties</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (invoice of invoices; track invoice.id) {
                                <tr class="clickable">
                                    <td>
                                        <a [routerLink]="['/orderdirect-inkoopfacturen', invoice.id]">{{
                                            invoice.od_bon_nr
                                        }}</a>
                                    </td>
                                    <td>{{ invoice.od_inkfak_nr || '-' }}</td>
                                    <td>{{ invoice.od_invoer_dat | date: 'EEE d MMM yyyy' }}</td>
                                    <td>{{ invoice.od_cred_nr }}</td>
                                    <td>{{ invoice.od_cred_naam }}</td>
                                    <td class="text-end">
                                        {{ invoice.od_prijs_ink | currency: 'EUR' : 'symbol' : '1.2-2' }}
                                    </td>
                                    <td class="text-end">
                                        {{
                                            invoice.od_tot_excl != null
                                                ? (invoice.od_tot_excl | currency: 'EUR' : 'symbol' : '1.2-2')
                                                : '-'
                                        }}
                                    </td>
                                    <td
                                        class="text-end"
                                        [class.text-white]="invoice.od_tot_excl === invoice.od_tot_incl">
                                        {{
                                            invoice.od_tot_incl != null
                                                ? (invoice.od_tot_incl | currency: 'EUR' : 'symbol' : '1.2-2')
                                                : '-'
                                        }}
                                    </td>
                                    <td
                                        class="text-end"
                                        [class.bg-success]="
                                            getAfasAmCrTotal(invoice) != null && amCrMatchesTotIncl(invoice)
                                        "
                                        [class.bg-danger]="
                                            getAfasAmCrTotal(invoice) != null && !amCrMatchesTotIncl(invoice)
                                        "
                                        [class.text-white]="getAfasAmCrTotal(invoice) != null">
                                        @if (getAfasAmCrTotal(invoice) != null) {
                                            {{ getAfasAmCrTotal(invoice) | currency: 'EUR' : 'symbol' : '1.2-2' }}
                                        } @else {
                                            <span class="text-muted">-</span>
                                        }
                                    </td>
                                    <td>
                                        @if (invoice.afas_liin) {
                                            <span class="badge bg-success">{{ invoice.afas_liin }}</span>
                                        } @else {
                                            <span class="text-muted">-</span>
                                        }
                                    </td>
                                    <td>
                                        <span
                                            class="badge"
                                            [ngClass]="getStatusClass(invoice | orderdirectPurchaseInvoiceStatus)">
                                            {{ getStatusLabel(invoice | orderdirectPurchaseInvoiceStatus) }}
                                        </span>
                                    </td>
                                    <td>
                                        @if (invoice.exception) {
                                            <span class="text-danger">{{ invoice.exception }}</span>
                                        } @else {
                                            <span class="text-muted">-</span>
                                        }
                                    </td>
                                    <td>{{ invoice.created_at | date: 'EEE d MMM yyyy HH:mm' }}</td>
                                    <td>
                                        @if (canSendToAfas(invoice)) {
                                            <button
                                                class="btn btn-sm btn-primary me-1"
                                                (click)="sendToAfas(invoice, $event)">
                                                <i class="fas fa-paper-plane"></i> Naar AFAS
                                            </button>
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <!-- Material Paginator -->
                <mat-paginator
                    class="mt-3"
                    [length]="totalItems"
                    [pageSize]="pageSize"
                    [pageIndex]="pageIndex"
                    [pageSizeOptions]="pageSizeOptions"
                    [showFirstLastButtons]="true"
                    (page)="onPageChange($event)">
                </mat-paginator>
            </div>
        </div>
    }
</div>
